import React from "react";
import diContainer from "true-di";
import { bool } from "prop-types";

import { maintenanceProvider } from "./provider";

const L_OFF = "OFF"; // maintenance mode is off
const L_NEW_ECOMM = "NEW_ECOMM"; // stop new ecommerce activity only
const L_NEW_ECOMM_AND_SIGNUPS = "NEW_ECOMM_AND_SIGNUPS"; // stop new ecommerce activity and new signups (including trials)
const L_CUD = "CUD"; // stop all activity modifying anything in the database (create, update, delete)

const LevelValue = {
	[L_OFF]: 0,
	[L_NEW_ECOMM]: 1,
	[L_NEW_ECOMM_AND_SIGNUPS]: 2,
	[L_CUD]: 3,
};

const WithMaintenance = ({ serviceCore, MaintenanceComp }) => ({ level: pageLevel }) => Page => {
	const PageWithMaintenance = ({ maintenance, ...pageProps }) => {
		return maintenance ? <MaintenanceComp /> : <Page {...pageProps} />;
	};

	PageWithMaintenance.propTypes = {
		maintenance: bool,
	};

	Object.assign(PageWithMaintenance, Page); // copying all static props

	PageWithMaintenance.getInitialProps = async (ctx, ...args) => {
		const { gqlClient } = diContainer({
			...serviceCore,
			globalContext: () => ctx,
		});

		const envLevel = await maintenanceProvider(gqlClient);

		// No need to run Page getInitialProps if maintance mode is on
		if (LevelValue[envLevel] >= LevelValue[pageLevel]) {
			return { maintenance: true };
		}

		let pageProps = {};

		if (Page.getInitialProps) {
			pageProps = await Page.getInitialProps(ctx, ...args);
		}

		return { maintenance: false, ...pageProps };
	};

	return PageWithMaintenance;
};

export default WithMaintenance;
